"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UnicodeNormalizationForm", {
  enumerable: true,
  get: function get() {
    return _utf.UnicodeNormalizationForm;
  }
});
Object.defineProperty(exports, "Utf8ErrorFuncs", {
  enumerable: true,
  get: function get() {
    return _utf.Utf8ErrorFuncs;
  }
});
Object.defineProperty(exports, "Utf8ErrorReason", {
  enumerable: true,
  get: function get() {
    return _utf.Utf8ErrorReason;
  }
});
Object.defineProperty(exports, "_toEscapedUtf8String", {
  enumerable: true,
  get: function get() {
    return _utf._toEscapedUtf8String;
  }
});
Object.defineProperty(exports, "formatBytes32String", {
  enumerable: true,
  get: function get() {
    return _bytes.formatBytes32String;
  }
});
Object.defineProperty(exports, "nameprep", {
  enumerable: true,
  get: function get() {
    return _idna.nameprep;
  }
});
Object.defineProperty(exports, "parseBytes32String", {
  enumerable: true,
  get: function get() {
    return _bytes.parseBytes32String;
  }
});
Object.defineProperty(exports, "toUtf8Bytes", {
  enumerable: true,
  get: function get() {
    return _utf.toUtf8Bytes;
  }
});
Object.defineProperty(exports, "toUtf8CodePoints", {
  enumerable: true,
  get: function get() {
    return _utf.toUtf8CodePoints;
  }
});
Object.defineProperty(exports, "toUtf8String", {
  enumerable: true,
  get: function get() {
    return _utf.toUtf8String;
  }
});

var _bytes = require("./bytes32");

var _idna = require("./idna");

var _utf = require("./utf8");